import React, { FC, useEffect, useState } from "react"
import Breadcrumb from '@/modules/productPc/Breadcrumb'
import * as Styles from './haul-detail.module.scss'
import Info from "@/modules/HaulDetail/Info"
import Relate from "@/modules/HaulDetail/Relate"
import { getHaulComment, getHaulDetail, getSimilarProduct } from "@/service/api"
import SEO from "./seo"

interface IProps {
  pageContext: any
  categoryId: string,
  p_id: string,
  c_id: string
}
const HaulDetail: FC<IProps> = ({ pageContext, categoryId, p_id, c_id }) => {
  const [haulInfo, setHaulInfo] = useState(() => {
    return pageContext.info || {}
  })

  const [breadCrumbList, setBreadCrubmList] = useState<any>(() => {
    return [
      { path: '/', term: '首页' },
      { path: '/haul', term: '晒单精选' },
      { path: '', term: pageContext?.info?.content || '' },
    ]
  })
  const [relateList, setRelateList] = useState(() => {
    return pageContext.relateList
  })
  const [similarProducts, setSimilarProducts] = useState(() => {
    return pageContext.similarProducts
  })

  useEffect(() => {
    getHaulDetail(p_id || pageContext.p_id, c_id || pageContext.c_id).then((res: any) => {
      setHaulInfo(res?.comments?.[0] || {})
      setBreadCrubmList([
        { path: '/', term: '首页' },
        { path: '/haul', term: '晒单精选' },
        { path: '', term: res?.comments?.[0]?.content || '' },
      ])
    }).catch(err => {
      console.log(err)
    })
  }, [c_id])

  useEffect(() => {
    // 获取推荐类目下的5个晒单
    const random = Math.floor(Math.random() * 99) + 1
    const q = `${categoryId === '0' ? `delimiter=${random}` : `page=${random}`}&size=5&category=${categoryId}`
    getHaulComment(q)
      .then((res: any) => {
        const data = res.waterFall?.waterDrops;
        if (data && data.length) {
          setRelateList(data)
        }
      })
  }, [c_id])

  useEffect(() => {
    // 获取3个相似商品
    getSimilarProduct(p_id || pageContext.p_id).then((res: any) => {
      setSimilarProducts(res.products.slice(0, 3))
    }).catch(err => {

    })
  }, [p_id])

  return <section className={Styles.continer}>
    <SEO
        title={`别样海外购_用户晒单详情频道 ｜ ${pageContext?.info?.content || haulInfo.content } | 别样海外购 bieyangapp.com`}
        description={`别样海外购_用户晒单详情频道 ｜ ${pageContext?.info?.content || haulInfo.content } | 别样海外购 bieyangapp.com`}
        keywords={`别样海外购_用户晒单详情频道 ｜ ${pageContext?.info?.content || haulInfo.content } | 别样海外购 bieyangapp.com`}
      />
    <Breadcrumb cate={breadCrumbList} />
    <div className={Styles.panel}>
      <Info info={haulInfo} similarProducts={similarProducts} />
      <Relate list={relateList} categoryId={categoryId} c_id={c_id || pageContext.c_id} />
    </div>
  </section>
}

export default HaulDetail